import VnsRepository from "@/repositories/vns/VnsRepository";
import PermissionsRepository from "@/repositories/vns/PermissionRepository";
import monitor from '@/storages/vns/MonitorStore'
import makeState from "@/storages/Base/State";
import makeGetters from "@/storages/Base/Getters";
import makeMutations from "@/storages/Base/Mutations";

export default {
    name: 'vns',
    namespaced: true,
    state: {
        ...makeState(),
        permissions : {
            list: []
        },
    },
    getters: {
        ...makeGetters(),
        allPermissions (state) {
            return state.permissions.list
        },
        allActive (state) {
            return state.list
        }
    },
    mutations: {
        ...makeMutations(),
        setAllPermissions (state, array) {
            state.permissions.list = array
        },
        setResume (state, resume) {
            state.resume = resume
        },
        setResumeLoading (state, boolean) {
            state.resume.isLoading = boolean
        },
        setAllActive (state, array) {
            state.list = array
        }
    },
    actions: {
        async listOne ({ commit, state }, id) {
            await VnsRepository.fetch(id).then(response => {
                commit('setCurrent', response.data.data)
            })
        },
        async listAll ({ commit }, params) {
            commit('setLoading', true)
            await VnsRepository.fetchAll(params).then(response => {
                commit('setAll', response.data.data)
            })
            commit('setLoading', false)
        },
        async listAllActive ({ commit }, params) {
            commit('setLoading', true)
            await VnsRepository.fetchAllActive(params).then(response => {
                commit('setAllActive', response.data.data)
            })
            commit('setLoading', false)
        },
        async search ({ commit, state }, params) {
            commit('setLoading', true)
            await VnsRepository.search(params).then(response => {
                if (response.data.data.vns.length > 0){
                    const array = response.data.data.vns
                    commit('setAll', Object.values([...state.list, ...array].reduce((acc,cur)=>Object.assign(acc,{[cur.id]:cur}),{})))
                }
            })
            commit('setLoading', false)
        },
        async listToMonitor ({ commit }, params) {
            commit('setLoading', true)
            await VnsRepository.fetchToMonitor(params).then(response => {
                commit('setAll', response.data.data)
            })
            commit('setLoading', false)
        },
        async listTable ({ commit }, params) {
            commit('setLoading', true)
            await VnsRepository.fetchTable(params).then(response => {
                commit('setAll', response.data.data.vns)
                if (response.data.data.meta && Object.keys(response.data.data.meta).length > 0){
                    commit('setPagination', response.data.data.meta)
                }
            })
            commit('setLoading', false)
        },
        async listAllPermissions ({ commit }, params) {
            commit('setLoading', true)
            await PermissionsRepository.fetchAll(params).then(response => {
                commit('setAllPermissions', response.data.data)
            })
            commit('setLoading', false)
        },
    },
    modules: {
        monitor
    }
}
